import React from 'react';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import amber from '@material-ui/core/colors/amber';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';


const variantIcon = {
    successInverse: CheckCircleIcon,
    error: ErrorIcon,
    info: InfoIcon,
    warningInverse: WarningIcon,
};

const styles = theme => ({
    successInverse: {
        color: green[600],
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    warningInverse: {
        color: amber[700],
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

function NotificationMessage(props) {

    const { classes, className, message, variant } = props;

    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="snackbar"
            message={<span id="snackbar" className={classes.message}><Icon className={classNames(classes.icon, classes.iconVariant)} /> <span dangerouslySetInnerHTML={{__html: message}}></span></span>}
        />
    );
}

NotificationMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    variant: PropTypes.oneOf(['successInverse', 'error', 'info', 'warningInverse']).isRequired
};

export default withStyles(styles)(NotificationMessage);



// WEBPACK FOOTER //
// ./src/utils/NotificationMessage.jsx